module.exports = __webpack_public_path__ + "img/ogrenci.76d3f66f.png";